/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import './styles.scss'

import MicroModal from 'micromodal'

class ResultsFilterModal {
  constructor (element) {
    this.$el = $(element)

    this.$contentObject = null

    this.$contentContainer = this.$el.find('.resultsFilterModal-content')
    this.$applyButton = this.$el.find('.resultsFilterModal-applyButton')

    MicroModal.init()
  }

  openModal ($content, onApply, onCancel, onClose) {
    this.$contentContainer.html('')
    this.$contentObject = $content
    this.$contentContainer.append(this.$contentObject)

    MicroModal.show('resultsFilterModal', {
      disableScroll: true,
      onClose: function () {
        if (onCancel) {
          onCancel()
        }
        if (onClose) {
          onClose()
        }
      }
    })

    if (onApply) {
      this.$applyButton.off('click').on('click', onApply)
      this.$applyButton.removeClass('u--hide')
    } else {
      this.$applyButton.off('click')
      this.$applyButton.addClass('u--hide')
    }
  }

  closeModal () {
    MicroModal.close('resultsFilterModal')
  }
}

registerClass('ResultsFilterModal', ResultsFilterModal)
